import { Typography } from "@mui/material"
import { Box } from "@mui/system"

const ExternalDetailsCard = ({ values, bgColor, title, t }) => {
  return (
    <Box mt={5}>
      <Typography mb={1} fontWeight={500} variant="h5">
        {title}
      </Typography>
      <Box
        flexWrap="wrap"
        borderRadius="2px"
        backgroundColor={bgColor}
        display="flex"
        flexDirection="row"
        p={4}
        alignItems="center"
        justifyContent="space-between">
        <Box>
          <Typography variant="bodySmall">{t("issuereports.reg_no", "Reg no")}</Typography>
          <Typography variant="h6">{values.regNumber}</Typography>
        </Box>
        <Box>
          <Typography variant="bodySmall">{t("global.chassis_number", "Chassis number")}</Typography>
          <Typography variant="h6">{values.chassiNumber}</Typography>
        </Box>
        <Box>
          <Typography variant="bodySmall">{t("global.year_model", "Year model")}</Typography>
          <Typography variant="h6">{values.vehicleYear}</Typography>
        </Box>
        <Box>
          <Typography variant="bodySmall">{t("global.model", "Model")}</Typography>
          <Typography variant="h6">{values.model}</Typography>
        </Box>
        <Box>
          <Typography variant="bodySmall">{t("global.manufacturer", "Manufacturer")}</Typography>
          <Typography variant="h6">{values.model?.split(" ")[0]}</Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default ExternalDetailsCard
